import { useStreamSelection } from '@app/modules/logger/screens/stream/stores/useStreamSelection';
import { AuditLiveMention, toTimestamp } from '@mi-front/core';
import { Visibility as VisibilityIcon } from '@mui/icons-material';
import { Button, Tooltip } from '@mui/material';
import { FormattedMessage } from 'react-intl';

export function LiveMentionShowButton(p: { liveMention: AuditLiveMention }) {
  const { setSelection } = useStreamSelection();

  if (!p.liveMention.customData?.time) {
    return null;
  }

  return (
    <Tooltip
      title={
        <FormattedMessage id="logger.liveMentions.showMention" defaultMessage="Mostrar mención" />
      }
    >
      <Button
        size="small"
        sx={{ marginTop: 0.5, marginLeft: 0.5 }}
        startIcon={<VisibilityIcon />}
        variant="outlined"
        color="primary"
        onClick={() => {
          setSelection(
            toTimestamp(p.liveMention.customData?.time.start),
            toTimestamp(p.liveMention.customData?.time.end),
          );
        }}
      />
    </Tooltip>
  );
}
